import SFetch from '@app/utils/sfetch'

export default {
  // The editor may hold unsaved changes when the graph is deleted. Clearing
  // the dirty flag keeps the redirect from asking about them.
  destroy(url) {
    return SFetch.jsonWithAlert(url, { method: 'DELETE' }).then((data) => {
      window.Silverfin.Dirty.clearDirty()
      window.Turbolinks.visit(data.redirectTo)
    })
  },
  save(url, method, body) {
    return SFetch.json(url, { method, body })
  },
  previewGraph(url, body) {
    return SFetch.json(url, { method: 'POST', body }, { camelizeJSON: false })
  },
  updateDrawer(url, body) {
    return SFetch.json(url, { method: 'PATCH', body })
  },
}
